import { useTheme } from "../Contexts/ThemeContext";

export function ThemeAppearanceSelect() {
  const { theme, setTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <div className="settings-row">
      <span>
        <i className={`bi ${isDark ? "bi-moon-stars" : "bi-sun"}`} aria-hidden /> Theme / Appearance
      </span>
      <label className="settings-toggle" aria-label="Toggle dark mode">
        <input
          type="checkbox"
          checked={isDark}
          onChange={(e) => setTheme(e.target.checked ? "dark" : "light")}
        />
        <span className="settings-toggle__track" aria-hidden="true" />
      </label>
    </div>
  );
}
